export const QUESTION_TYPES = [
  { value: 0, label: 'A1型题', shortLabel: 'A1型题' },
  { value: 1, label: 'A2型题', shortLabel: 'A2型题' },
  { value: 2, label: 'A3型题', shortLabel: 'A3型题' },
  { value: 3, label: 'A4型题', shortLabel: 'A4型题' },
  { value: 4, label: 'B型题', shortLabel: 'B型题' },
  { value: 5, label: 'X型题', shortLabel: 'X型题' },
  { value: 6, label: '判断题', shortLabel: '判断题' },
  { value: 7, label: '填空题', shortLabel: '填空题' },
  { value: 8, label: '问答题', shortLabel: '问答题' }
]

export const SKILL_CENTER_GROUP_STORAGE_KEY = 'practice-skill-question-groups'

export function readSkillCenterGroupRecords() {
  try {
    const records = JSON.parse(localStorage.getItem(SKILL_CENTER_GROUP_STORAGE_KEY) || '[]')
    return Array.isArray(records) ? records : []
  } catch (error) {
    return []
  }
}

export function writeSkillCenterGroupRecords(records) {
  localStorage.setItem(
    SKILL_CENTER_GROUP_STORAGE_KEY,
    JSON.stringify(Array.isArray(records) ? records : [])
  )
}

export function questionTypeLabel(type) {
  const target = QUESTION_TYPES.find((item) => {
    if (item.values) return item.values.map(String).includes(String(type))
    return String(item.value) === String(type)
  })
  return target ? target.label : '题目'
}

export function parseQueryArray(value) {
  if (Array.isArray(value)) return value.map(String)
  if (!value) return []
  try {
    const data = JSON.parse(value)
    return Array.isArray(data) ? data.map(String) : []
  } catch (error) {
    return String(value)
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
  }
}

export function parseAnswer(value) {
  if (value === undefined || value === null || value === '') return []
  const text = String(value)
  return text.includes(',')
    ? text.split(',').filter(Boolean)
    : text.split('').filter(Boolean)
}

export function isAnswerRight(question, result) {
  if (!result || Number(question.type) === 8) return null
  if (Number(question.type) === 5) {
    return parseAnswer(result).sort().join('') ===
      parseAnswer(question.correct).sort().join('')
  }
  return String(result) === String(question.correct || '')
}

export function flattenQuestions(rows) {
  return (rows || [])
    .map((question) => {
      if (question.childedList && question.childedList.length) {
        return question.childedList.map((child) => ({
          ...child,
          publicContent: question.content,
          publicFileUrl: question.fileUrl,
          publicFileName: question.fileName,
          // 复合题的题型由父题定义（A3/A4 等），子题 type 仅是子题数据属性。
          // 保留父题型才能让答题卡筛选和详情页左右切题使用同一题目序列。
          type: question.type !== undefined && question.type !== null
            ? question.type
            : child.type
        }))
      }
      return question
    })
    .flat()
}

export function normalizeQuestions(rows, records) {
  const recordMap = new Map(
    (records || []).map((record) => [String(record.questionId || record.id), record])
  )
  return flattenQuestions(rows).map((question) => {
    const record = recordMap.get(String(question.id)) || {}
    const result = record.result || question.result || ''
    const isRight = record.isRight === undefined || record.isRight === null
      ? question.isRight
      : record.isRight
    const selectedList = parseAnswer(result)
    const normalized = {
      ...question,
      result,
      isFavorite:
        record.isFavorite === undefined || record.isFavorite === null
          ? question.isFavorite || 0
          : record.isFavorite,
      mark: record.mark || question.mark || '',
      isRight: isRight === undefined || isRight === null
        ? isAnswerRight(question, result)
        : Number(isRight) === 1,
      selectList: (question.selectList || []).map((option) => ({
        ...option,
        selected: selectedList.includes(option.type)
      }))
    }
    if (Number(normalized.type) === 5) normalized.selectedList = selectedList
    if (Number(normalized.type) === 7) {
      const resultList = result ? String(result).split('[$]') : []
      normalized.correctList = normalized.correct
        ? String(normalized.correct).split('[$]')
        : []
      normalized.blanksList = normalized.correctList.map((item, index) => ({
        correct: item,
        name: resultList[index] || ''
      }))
    }
    return normalized
  })
}

export function nodeId(node) {
  return String(node.categoryId || node.id || node.questionId || '')
}

export function nodeLabel(node) {
  return node.label || node.categoryName || node.name || node.title || node.categoryTypeName || '未命名'
}

export function nodeCount(node) {
  const totalNum = node && node.totalNum
  const questionCount = node && node.questionCount
  if (Number(totalNum) > 0) return Number(totalNum)
  if (Number(questionCount) > 0) return Number(questionCount)
  const children = treeChildren(node)
  if (children.length) {
    return children.reduce((total, child) => total + Number(nodeCount(child) || 0), 0)
  }
  return Number(totalNum || questionCount || 0)
}

export function nodeResourceCount(node, resourceType) {
  const field = {
    wrong: 'wrongCount',
    favorite: 'favoriteCount',
    note: 'noteCount'
  }[resourceType]
  if (!field) return 0
  const value = node && node[field]
  if (Number(value) > 0) return Number(value)
  const children = treeChildren(node)
  if (children.length) {
    return children.reduce((total, child) => {
      return total + nodeResourceCount(child, resourceType)
    }, 0)
  }
  return value === undefined || value === null
    ? Number(nodeCount(node) || 0)
    : Number(value || 0)
}

export function filterResourceTree(nodes, resourceType) {
  return (nodes || []).reduce((result, node) => {
    const children = filterResourceTree(treeChildren(node), resourceType)
    if (nodeResourceCount(node, resourceType) > 0 || children.length) {
      result.push({ ...node, children })
    }
    return result
  }, [])
}

export function collectLeafIds(node) {
  const children = node.children || []
  if (!children.length) return nodeId(node) ? [nodeId(node)] : []
  return children.reduce((result, child) => result.concat(collectLeafIds(child)), [])
}

export function mediaUrl(vm, path) {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  return `${vm.imgUrl || ''}${String(path).replace(/^\//, '')}`
}

export function treeChildren(node) {
  return node && Array.isArray(node.children) ? node.children : []
}

export function skillCenterTreeData(response) {
  if (Array.isArray(response)) return response
  if (response && Array.isArray(response.data)) return response.data
  if (response && response.data && Array.isArray(response.data.list)) {
    return response.data.list
  }
  if (response && Array.isArray(response.list)) return response.list
  return []
}

export function skillCenterFirstLevelCategories(tree) {
  return (tree || []).reduce((result, root) => {
    if (root && root.virtualNode === false && Number(root.storageLevel) === 1) {
      result.push(root)
      return result
    }
    return result.concat(treeChildren(root).filter((item) => {
      return item && item.virtualNode === false && Number(item.storageLevel) === 1
    }))
  }, [])
}

export function nestedResourceTree(node, resourceKey) {
  if (!node) return []
  const resource = node[resourceKey]
  const rows = resource && Array.isArray(resource.tree)
    ? resource.tree.filter(Boolean)
    : []
  return treeChildren(node).reduce((result, child) => {
    return result.concat(nestedResourceTree(child, resourceKey))
  }, rows)
}

function resourceEntryNodes(tree) {
  return (tree || []).reduce((result, node) => {
    const children = treeChildren(node)
    if (children.length) return result.concat(children)
    if ((Array.isArray(node && node.skills) && node.skills.length) ||
      nodeCount(node) > 0 || (node && node.categoryId)) {
      result.push(node)
    }
    return result
  }, [])
}

function resourceCategoryChildren(node, resourceKey) {
  return treeChildren(node).filter((child) => {
    return nestedResourceTree(child, resourceKey).length > 0
  })
}

export function questionResourceRows(station) {
  const categoryChildren = resourceCategoryChildren(station, 'question')
  if (categoryChildren.length) {
    return categoryChildren.map((category) => ({
      ...category,
      children: resourceEntryNodes(nestedResourceTree(category, 'question'))
    }))
  }
  return resourceEntryNodes(nestedResourceTree(station, 'question'))
}

export function nodeOrganCategoryId(node) {
  return String((node && (node.organCategoryId || node.id)) || '')
}

export function findSkillCenterCategory(tree, categoryOrganId, majorType) {
  const categories = skillCenterFirstLevelCategories(tree)
  return categories.find((item) => nodeOrganCategoryId(item) === String(categoryOrganId || '')) ||
    categories.find((item) => String(item.categoryType) === String(majorType || '')) ||
    null
}

export function questionStationResources(category, organCategoryId) {
  let stations = treeChildren(category).filter((item) => {
    return item && item.virtualNode === false && Number(item.storageLevel) === 2 &&
      (Number(item.type) === 2 || nestedResourceTree(item, 'question').length)
  })
  if (organCategoryId) {
    const selected = stations.find((item) => nodeOrganCategoryId(item) === String(organCategoryId))
    if (selected) stations = [selected]
  }
  return stations.map((station) => ({
    station,
    roots: questionResourceRows(station)
  })).filter((item) => item.roots.length)
}

export function skillCenterQuestionCategories(
  tree,
  majorType,
  categoryOrganId = '',
  organCategoryId = ''
) {
  const categories = skillCenterFirstLevelCategories(tree)
  const categoryId = String(categoryOrganId || '')
  const category = categories.find((item) => {
    return [
      item.organCategoryId,
      item.categoryOrganId,
      item.categoryId,
      item.id,
      item.nodeId
    ].some((id) => String(id || '') === categoryId)
  }) || categories.find((item) => {
    return String(item.categoryType) === String(majorType || '')
  }) || null
  if (!category) return []
  let stations = treeChildren(category).filter((station) => {
    return station && station.virtualNode === false && Number(station.storageLevel) === 2 &&
      (Number(station.type) === 2 || nestedResourceTree(station, 'question').length)
  })
  if (organCategoryId) {
    const selected = stations.find((station) => {
      return nodeOrganCategoryId(station) === String(organCategoryId)
    })
    if (selected) stations = [selected]
  }
  const questionCategories = stations.reduce((result, station) => {
    result.push(...questionResourceRows(station))
    return result
  }, [])
  const unique = new Map()
  questionCategories.forEach((item) => unique.set(nodeId(item), item))
  return Array.from(unique.values())
}
